import React from 'react';

export const AscendingIcon = ({ backgroundColor }) => {
  return (
    <svg
      width="15"
      height="10"
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ascendingicon"
    >
      <path
        id="Vector"
        d="M7.06 4.5L4 2.02767L0.94 4.5L1.93686e-07 3.73887L4 0.5L8 3.73887L7.06 4.5Z"
        fill={backgroundColor}
      />
    </svg>
  );
};

export const DescendingIcon = ({ backgroundColor }) => {
  return (
    <svg
      width="15"
      height="10"
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="descendingicon"
    >
      <path
        id="Vector"
        d="M0.94 0.5L4 2.97233L7.06 0.5L8 1.26113L4 4.5L0 1.26113L0.94 0.5Z"
        fill={backgroundColor}
      />
    </svg>
  );
};
